import axios from 'axios';
import buildStr from "../strbuilder";

const orderApi = {
  async getOrders(addressId) {
    if (!addressId) return [];
    const response = await axios.get(`/api/Address/${addressId}/Order`);
    return response.data;
  },
  async getOrder(orderId) {
    const response = await axios.get(`/api/Order/${orderId}`);
    return response.data;
  },
  async getOrderPayments(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/Payment`);
    return response.data;
  },
  async getOrderDeliveries(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/Delivery`);
    return response.data;
  },
  async getOrderReclamations(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/ReclamationRow`);
    return response.data;
  },
  async getOrderProductRows(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/ProductRow`);

    const rows = response.data;

    return buildStr(rows);
  },
  async getOrder3dModels(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/Showroom`);
    const rows = response.data;
    return rows;
  },
  async getOrderWarrantyData(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/WarrantyData`);
    return response.data;
  },
  async getOrderDeliveryData(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/DeliveryData`);
    return response.data;
  },
  async getOrderDocuments(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/Document`);
    return response.data;
  },
  async getOrderBackorders(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/Backorder`);
    return response.data;
  },
  async getOrderShares(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/Share`);
    return response.data;
  },
  async updateOrderShare(orderId, shareId, data) {
    const response = await axios.post(`/api/Order/${orderId}/Share/${shareId}`, data);
    return response.data;
  },
  async deleteOrderShare(orderId, shareId) {
    const response = await axios.delete(`/api/Order/${orderId}/Share/${shareId}`);
    return response.data;
  },
  async addOrderInvitation(orderId, data) {
    const response = await axios.post(`/api/Order/${orderId}/Invitation`, data);
    return response.data;
  },
  async getOrderInvitations(orderId) {
    const response = await axios.get(`/api/Order/${orderId}/Invitation`);
    return response.data;
  },
  async deleteOrderInvitation(orderId, invitationId) {
    const response = await axios.delete(`/api/Order/${orderId}/Invitation/${invitationId}`);
    return response.data;
  },
}

export default orderApi;
